export const downloadFile = (payload, fallbackFilename) => {
  const url = URL.createObjectURL(payload.data);
  const link = document.createElement("a");
  link.href = url;
  const disposition = payload.headers?.["content-disposition"];
  const filename = disposition
    ? disposition.split("filename=").pop().replace(/"/g, "")
    : fallbackFilename;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
